// Isolated B2B catalogue API helpers. Reuses the shared axios instance
// (attaches the JWT when present) for admin calls; public calls work without a
// token. Kept separate from ERP API code so the module stays removable.
import { api, API_BASE } from "@/lib/apiClient";

const BACKEND_URL = API_BASE.replace(/\/api$/, "");

// Path prefix: on the b2b.* subdomain the catalogue lives at the root; in the
// shared preview app it lives under /b2b so it can be tested without DNS.
export const isB2BHost = () =>
  typeof window !== "undefined" && window.location.hostname.startsWith("b2b.");
export const b2bBase = () => (isB2BHost() ? "" : "/b2b");

// Turn a stored media url ("/api/b2b/public/media/:id") into a renderable src.
export const mediaSrc = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  return `${BACKEND_URL}${url}`;
};

// ---- Public (no auth) ----
export const fetchPublicMeta = () => api.get("/b2b/public/meta").then((r) => r.data);
export const fetchPublicLots = (params) => api.get("/b2b/public/lots", { params }).then((r) => r.data);
export const fetchPublicLot = (lotNumber) =>
  api.get(`/b2b/public/lots/${encodeURIComponent(lotNumber)}`).then((r) => r.data);

// ---- Admin (auth) ----
export const fetchAdminStats = () => api.get("/b2b/admin/stats").then((r) => r.data);
export const fetchAdminLots = (params) => api.get("/b2b/admin/lots", { params }).then((r) => r.data);
export const fetchAdminLot = (id) => api.get(`/b2b/admin/lots/${id}`).then((r) => r.data);
export const createLot = (body) => api.post("/b2b/admin/lots", body).then((r) => r.data);
export const updateLot = (id, body) => api.put(`/b2b/admin/lots/${id}`, body).then((r) => r.data);
export const duplicateLot = (id, newLotNumber) =>
  api.post(`/b2b/admin/lots/${id}/duplicate`, null, { params: { new_lot_number: newLotNumber } }).then((r) => r.data);
export const archiveLot = (id, archived) =>
  api.post(`/b2b/admin/lots/${id}/archive`, null, { params: { archived } });
export const deleteLot = (id) => api.delete(`/b2b/admin/lots/${id}`);
export const uploadMedia = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/b2b/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const fetchSettings = () => api.get("/b2b/admin/settings").then((r) => r.data);
export const saveSettings = (body) => api.put("/b2b/admin/settings", body).then((r) => r.data);
